import useGetUserInfo from "features/users/hooks/useGetUserInfo";
import { UseQueryResult } from "react-query";
import type { RoleDto } from "common/models/api/models/RoleDto";

export default function useRoleOptions(): UseQueryResult<RoleDto[]> {
    return useGetUserInfo({ select: (user) => user?.roles || [] });
}
